var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inter"},[_c('img',{staticClass:"interani",attrs:{"src":"http://resali.lititutu.cn/icons/other/10.png"}})])}]

export { render, staticRenderFns }